import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/app/lib/environment';
import { Urls } from 'src/app/lib/urls';
import { RequestsService } from 'src/app/core/services/http/requests.service';
import { Observable } from 'rxjs';
import * as vo from '../../core/model/server/vo/_index';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(
    private http: HttpClient,
    private env: environment,
    private request: RequestsService
  ) { }

  login(username: string, password: string): Observable<vo.UserLoginResponse> {
    const httpOptions = {
        headers: new HttpHeaders({
            Authorization: 'Basic ' + btoa(username + ':' + password)
        })
    };

    return this.http.get<vo.UserLoginResponse>(this.env.getUrl(Urls.login), httpOptions);
  }

  saveLoginData(response: any, username: string, password: string) {
    localStorage.setItem('sessionId', response.result.sessionId);
    localStorage.setItem('username', username);
    localStorage.setItem('loginTime', response.result.loginTime);

    localStorage.setItem('firstName', response.result.firstName);
    localStorage.setItem('lastName', response.result.lastName);
    localStorage.setItem('accountType', response.result.accountType);
    localStorage.setItem('uid', response.result.uid);

    const encodedPassword = btoa(password);
    localStorage.setItem('encodedPassword', encodedPassword);
  }

  sendForgotPasswordEmail(username: string, redirectUrl: string): Promise<vo.SendForgotPasswordEmailResponse> {
    const payload: vo.SendForgotPasswordEmailRequest = {
        username,
        redirectUrl,
    };

    return this.request.post(Urls.sendForgotPasswordEmail, payload);
  }
}
